import request from "@/api/request";

class TrackingService {
  static async track(name: string, properties: object): Promise<void> {
    await request.post("/track", { name, properties });
  }
}

export default TrackingService;
